import { reaction } from 'mobx';
import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

import { crewTimelineStore } from './CrewTimelineStore';

export function useFilterQueryParams() {
	const initializedRef = useRef(false);
	const [searchParams, setSearchParams] = useSearchParams();

	useEffect(() => {
		if (initializedRef.current) return;

		initializedRef.current = true;

		const applied = crewTimelineStore.applyQueryParams(searchParams);

		if (applied) return;

		const params = crewTimelineStore.toQueryParams();

		if (Object.keys(params).length) setSearchParams(params, { replace: true });
	}, [searchParams, setSearchParams]);

	useEffect(() => {
		const dispose = reaction(
			() => crewTimelineStore.toQueryParams(),
			(params) => setSearchParams(params, { replace: true }),
			{ fireImmediately: false }
		);

		return () => dispose();
	}, [setSearchParams]);
}
